// src/utils/utils.js

// Utility function to retrieve the bearer token from localStorage
export const getAuthToken = () => {
  const authResponseData = localStorage.getItem("authResponseData");
  if (authResponseData) {
    const { token } = JSON.parse(authResponseData);
    return token;
  }
  throw new Error("Please sign in.");
};

// Utility function to generate a random number
export const generateRandomNumber = () => {
  return Math.floor(Math.random() * 10000000); // Generates a random number between 0 and 9,999,999
};

export const toISOStringMidnightUTC = (dateStr) => {
  if (!dateStr) {
    return null; // Return null if the date string is not provided
  }

  const [year, month, day] = dateStr.split("-").map(Number);
  if (isNaN(year) || isNaN(month) || isNaN(day)) {
    return null; // Return null if the date string is invalid
  }

  // Note: Months are zero-indexed in JavaScript Date objects
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.toISOString();
};

// Function to get today's date in YYYY-MM-DD format
export const getLocalToday = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0");
  const day = now.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const validateChallengeFields = (formData) => {
  const newErrors = {};
  const today = getLocalToday();
  const startDate = formData.startDate ? formData.startDate : null;
  const endDate = formData.endDate ? formData.endDate : null;
  const fulfillmentDate = formData.fulfillmentDate
    ? formData.fulfillmentDate
    : null;

  if (!formData.title) newErrors.title = "Title is required";
  if (!formData.description) newErrors.description = "Description is required";
  if (!formData.prize) newErrors.prize = "Prize is required";

  // Start date validation
  if (!formData.startDate) {
    newErrors.startDate = "Start date is required";
  } else if (startDate < today) {
    newErrors.startDate = "Start date cannot be in the past.";
  }

  // End date validation
  if (!formData.endDate) {
    newErrors.endDate = "End date is required";
  } else if (endDate <= startDate) {
    newErrors.endDate = "End date must be after the start date.";
  }

  // Fulfillment date validation
  if (!formData.fulfillmentDate) {
    newErrors.fulfillmentDate = "Fulfillment date is required";
  } else if (fulfillmentDate < endDate) {
    newErrors.fulfillmentDate = "Fulfillment date must be after the end date.";
  }

  // Submission fee validation
  if (formData.chargeSubmissionFee) {
    if (
      formData.submissionFee === "" ||
      formData.submissionFee === undefined ||
      formData.submissionFee <= 0
    ) {
      newErrors.submissionFee =
        "Submission fee is required and must be greater than 0.";
    }
  }

  // Hero image validation
  if (!formData.hero) {
    newErrors.hero = "Cover image is required."; // Update to use `hero` instead of `heroImage`
  }

  return newErrors;
};

export const getSnackbarErrorMessage = (fieldErrors) => {
  let errorMessage = "Please address the following issues: ";
  const issues = [];
  if (fieldErrors.title) issues.push("Title is missing.");
  if (fieldErrors.description) issues.push("Description is missing.");
  if (fieldErrors.prize) issues.push("Prize is required.");
  if (fieldErrors.hero) issues.push("Cover image is required."); // Update to use `hero` instead of `heroImage`
  if (fieldErrors.submissionFee)
    issues.push("Submission fee is required and must be greater than 0.");
  if (fieldErrors.startDate) issues.push(fieldErrors.startDate);
  if (fieldErrors.endDate) issues.push(fieldErrors.endDate);
  if (fieldErrors.fulfillmentDate) issues.push(fieldErrors.fulfillmentDate);
  errorMessage += issues.join(" ");
  return errorMessage;
};

// Utility function to convert Uint8Array to base64 string
export const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary); // Encode the binary data into base64
};
